/** Shape of the scenario DSL the structured editor works with (U6). */
export interface DraftTransition {
  to: string;
  when: string;
}

export interface DraftStage {
  id: string;
  instruction?: string;
  goal?: string;
  allowed_links?: string[];
  must_include_opt_out?: boolean;
  collect?: string[];
  goal_on_agree?: 'meeting' | 'request';
  transitions?: DraftTransition[];
}

export interface DraftExample {
  question: string;
  answer: string;
}

export interface DraftStyle {
  max_chars?: number;
  address?: 'вы' | 'ты';
  emoji?: 'none' | 'rare' | 'ok';
  message_length?: 'short' | 'medium' | 'long';
}

export interface ScenarioDraft {
  goal?: string;
  persona_prompt?: string;
  facts?: string[];
  product_facts?: string[];
  rules?: string[];
  examples?: DraftExample[];
  style?: DraftStyle;
  stage_mode?: 'guided' | 'soft';
  tone?: string;
  stop_topics?: string[];
  opt_out_hint?: string;
  entry_stage?: string;
  stages?: DraftStage[];
  [key: string]: unknown;
}

export const EMPTY_DRAFT: ScenarioDraft = {
  goal: 'Договориться о звонке',
  persona_prompt: '',
  facts: [],
  rules: [],
  examples: [],
  style: { address: 'вы', emoji: 'none', message_length: 'short' },
  stage_mode: 'soft',
  stop_topics: [],
  opt_out_hint: 'Если неактуально — напишите «стоп».',
  entry_stage: 'greet',
  stages: [{ id: 'greet', instruction: 'Поздоровайся и задай вопрос.', goal: 'Завязать разговор', transitions: [] }],
};
